import { setGroupId, setMainRole } from "../../features/base/conference";
import { connectionDisconnect, connectionFailed, connectionSuccess, connectionWillConnect } from "../../features/base/connection";
import { getLocalUserUUID } from "../../features/base/localuser";
import { checkGroupPermission, checkMeetingRole, ROLE } from "../../features/base/participants";
import { setAssignGroupId, setGroupStatus } from "../../features/group/action";
import { GROUP_DEFAULT_NAME } from "../../features/group/constants";
import { CHECKING_ROOM_PASSWORD_MODAL_ID } from "../../features/options";
import { setRoomLocked } from "../../features/room-lock";
import { initGroup } from "./MateConference";

export default function MateConnection(mate) {
    this.mate = mate;

    this.connecting = false;
}

MateConnection.prototype.constructor = MateConnection;

MateConnection.prototype.connect = async function() {
    if (this.connecting === false) {
        this.connecting = true;

        const { dispatch, getState } = APP.store;
        const state = getState();

        // 방 잠금 여부 확인
        const { message, complete } = await checkRoomLocked(this.mate.groupId);
        
        if (complete) {
            // 내가 속해 있는 그룹 사용자 확인 (그룹이 시작 되어있는 경우에만)
            const { message, complete } = await checkStartGroup(this.mate.groupId);

            if (complete) {
                const websocket = new WebSocket(`wss://${location.host}/svc/room/ws${this.mate.groupId ? `?${this.mate.groupId}` : ``}`);
            
                dispatch(connectionWillConnect(websocket, this.mate.type));

                websocket.addEventListener('open', () => {
                    this.mate.setWebsocket(websocket);

                    this.mate.events.setAuth();

                    dispatch(connectionSuccess(this.websocket, this.mate.type));
                });

                websocket.addEventListener('close', () => {
                    this.connecting = false;
                    dispatch(connectionDisconnect(this.mate.type));
                });
                
                websocket.addEventListener('error', ev => {
                    this.connecting = false;
                    dispatch(connectionFailed(ev, this.mate.type));
                });

                websocket.addEventListener('message', (event) => { 
                    this.mate.events.reciveCommand(event);
                }); 
                return;
            }                       
        }
        this.connecting = false;
    } else {
        // 연결중 
        // alert("연결 중 입니다.", this.mate.groupId);
    }  
}


MateConnection.prototype.disconnect = function() {
    APP.store.dispatch(connectionDisconnect(this.mate.type));
    if (this.mate.websocket) this.mate.websocket.close();
}

MateConnection.prototype.unsetConnect = function() {
    if (this.mate.websocket) this.mate.websocket.close();
    this.connecting = false;
    this.mate.setWebsocket(null);
}

async function checkStartGroup(groupId) {
    if (groupId) {
        return { complete: true, message: true }
    }
    // 그룹 조회 
    const { dispatch, getState } = APP.store;
    const state = getState();

    const localId = getLocalUserUUID(state);
    const main_role = await checkMeetingRole(localId);
    dispatch(setMainRole(main_role));
    
    const response = await APP.API.getGroupList();

    let groupStart = false;
    let group_id = null;
    if (response.complete) {
        const groups = response.message;
        
        Object.keys(groups).map(uuid => {
            if (uuid === GROUP_DEFAULT_NAME) return;
            const group = groups[uuid];
            if (group.members && group.members.find(i => i.user_id === localId)) {
                dispatch(setAssignGroupId(uuid)); // 내가 지금 현재 할당 되어있는 그룹 
                if (group.status === 'opened') group_id = uuid;
            }

            if (group.status === 'opened') {
                groupStart = true;               
                return;
            }
        });
    }

    // 그룹 실행 여부 
    dispatch(setGroupStatus(groupStart));
    
    return response;
}

async function getMyConferenceRole(localId) {
    // 현재 본 그룹에서 나의 role을 가져옴
    let myRole = ROLE.PARTICIPANT;
    try {
        const { complete, message } = await APP.API.getAllParticipant({ user_id: localId, group_id: "" });

        if (complete) {
            myRole = message[0].role.name;
        }
        return myRole;
    } catch {
        return myRole;
    }
    
}

async function checkRoomLocked(groupId) {
    if (groupId) {
        return { complete: true, message: true }
    }
    const { dispatch, getState } = APP.store;
    const state = getState();

    const code = APP.mateManagement.getRoom('code');
    const aToken = APP.mateManagement.getAccessToken();

    const { message, complete } = await APP.API.searchRoom({ data: { code }, aToken });

    let isLocked = false;
    if (complete) {
        if (message.found_count > 0) {
            isLocked = message.items[0].password_checking ? true : false;
            dispatch(setRoomLocked(isLocked));
        }
    } 

    if (isLocked) {
        const password = state['features/room-lock'].password;
        if (!password) {
            APP.UI.openModal(CHECKING_ROOM_PASSWORD_MODAL_ID);

            APP.UI.showLoading(false);
            return { message, complete: false }; 
        }
    }

    return { message, complete };
}   